;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { personalizedResource } from '@/lib/resources/personalized-resource';

// types
import type { ContinueWatchingContent } from '@/lib/types/api/home-data'

export const continueWatching = personalizedResource<ContinueWatchingContent>({
  key: 'continueWatching',
  endpoint: '/api/profile/continue-watching/',
  select: (json) => (json as { continueWatchingData: ContinueWatchingContent[] | null }).continueWatchingData,
})
